//import 'bootstrap';
// Import just what we need

//import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import * as Modal from 'bootstrap/js/dist/modal'
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';

// Custom scripts
import setScrollPadding from "./frontend/scrollPadding";
import servicesOverviewSlider from "./frontend/slider";
import menuInit from "./frontend/menu";
import accordionScrollTop from './frontend/accordionScrollTop';
//import footerConsentmanagerTrigger from "./frontend/consentmanager";
import intersectionObserverMagic from "./frontend/animationObserver";
import handleFilter from './frontend/handleFilter';
import filterObserver from './frontend/filterObserver';
import runMap from './frontend/map';
import consentManagerHandleBackground from "./frontend/consentManagerHandleBackground";
import handleImageRotation from "./frontend/handleImageRotation";
import checkIfCorrectTimeModalContent from "./frontend/checkIfCorrectTimeModalContent";

let timeoutId = null;
const documentHeight = () => {
    clearTimeout(timeoutId); // avoid execution of previous timeouts
    timeoutId = setTimeout(() => {
        const doc = document.documentElement;
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }, 200);
};
const modal = document.querySelector('.csp-help-modal');
const newModal = new Modal(modal);
let modalWasShown = sessionStorage['cspModalShown'];
if (modalWasShown === undefined || modalWasShown === '') {

    newModal.show();
    modal.addEventListener('hidden.bs.modal', ev => {
        let mainMenu = document.getElementById('menu-hauptmenue');
        let firstLink = mainMenu.querySelector('.nav-link');
        if (window.hasOwnProperty('__cmp') && typeof __cmp !== 'undefined') {
            let consentStatus = __cmp('consentStatus');
            if (!consentStatus.userChoiceExists) {
                __cmp('showScreen');
            }else{
                firstLink.focus();
            }

        }
    }, {once: true});
    sessionStorage['cspModalShown'] = 'true';
}
if(modalWasShown === true){
    if (window.hasOwnProperty('__cmp') && typeof __cmp !== 'undefined') {
        let consentStatus = __cmp('consentStatus');
        if (!consentStatus.userChoiceExists) {
            __cmp('showScreen');
        }
    }
}
let rotationSet = null;
document.onreadystatechange = () => {
    if (document.readyState === 'complete') {

        servicesOverviewSlider();
        handleFilter();
        accordionScrollTop();

        consentManagerHandleBackground();
        let isCached = performance.getEntriesByType("navigation")[0].transferSize === 0;
        if(isCached){
            checkIfCorrectTimeModalContent();
        }


    }
}
window.addEventListener('load', () => {

    setScrollPadding();
    documentHeight();
    menuInit();
    intersectionObserverMagic();
    if(document.getElementById('csp-map')){
        runMap();
    }

    rotationSet = handleImageRotation();


});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    documentHeight();
    if (currentWidth === window.innerWidth) return;
    setScrollPadding();
    servicesOverviewSlider();
    handleImageRotation(true, rotationSet);
   // setStickyHeight(true);
    currentWidth = window.innerWidth;

});
window.addEventListener('orientationchange', function () {

    setScrollPadding();
});
document.addEventListener('cspMapSection', ev =>{
    filterObserver(true);
});